import Ink from "react-ink";

import styles from "./AppTile.module.css";

interface Props {
  title: string;
  icon: string;
  handleClick: () => void;
  readonly: boolean;
  requiredRoles: string[];
  tooltip?: string;
}

const AppTile = (props: Props) => {
  const { title, tooltip, icon, handleClick, readonly } = props;
  return (
    <div
      className={`${styles.AppTile} ${readonly ? styles.Disabled : styles.Enabled}`}
      onClick={!readonly ? handleClick : undefined}
      title={readonly ? tooltip : undefined}
    >
      <img src={icon} alt={title} className={styles.Img} />
      <p className={styles.Title}>{title}</p>
      {!readonly ? <Ink /> : null}
    </div>
  );
};

export default AppTile;
